import { useState, useEffect, useContext } from 'react';
import { Offcanvas } from "react-bootstrap";


import RefreshContext from "../RefreshContext";
import apiClient from "../lib/apiClient";
import Dollars from "./Dollars";
import EditPayee from "./EditPayee";

export default function TransactionOverlay({ transactionId, onClose }) {
  const [transaction, setTransaction] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [categories, setCategories] = useState(null);
  const [payeeName, setPayeeName] = useState(null);
  const [category, setCategory] = useState(null);
  const [payeeNames, setPayeeNames] = useState(null);

  const { refresh } = useContext(RefreshContext);

  useEffect(() => {
    async function fetchTransaction() {
      const { data } = await apiClient.get(`/api/transactions/${transactionId}`);
      setTransaction(data);
      setPayeeName(data.payee_name);
      setCategory(data.category);
    }

    fetchTransaction();
  }, [transactionId]);

  async function onSave() {
    const { data } = await apiClient.put(`/api/transactions/${transaction.id}`, { payee_name: payeeName, category });
    setIsEditing(false);
    setTransaction(data);
    refresh();
    onClose();
  }

  useEffect(() => {
    async function fetchCategories() {
      const { data } = await apiClient.get("/api/categories/all");
      setCategories(data);
    }

    fetchCategories();
  }, []);

  async function onPayeeChange(e) {
    const name = e.target.value;
    setPayeeName(name);

    if (name.length < 1) {
      setPayeeNames([]);
      return;
    }
    const { data } = await apiClient.get(`/api/payees/search?q=${name}`);
    setPayeeNames(data);
  }
  if (!transaction) return "";

  return (
    <Offcanvas show placement="end" onHide={onClose}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Transaction</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        {categories && <datalist id="categories">
          {categories.map(c => <option key={c.id} value={c.name} />)}
        </datalist>}
        {payeeNames && <datalist id="payees">
          {payeeNames.map(p => <option key={p} value={p} />)}
        </datalist>}
        <dl>
          <dt>Date</dt>
          <dd>{transaction.date}</dd>
          <dt>Amount</dt>
          <dd><Dollars amount={transaction.amount} withCents /></dd>
          {isEditing && <>
            <dt>Payee</dt>
            <dd>
              <input type="text"
                value={payeeName}
                list="payees"
                onChange={onPayeeChange}
                className="form-control"
                placeholder="Name" />
            </dd>
            <dt>Category</dt>
            <dd>
              <input type="text"
                list="categories"
                value={category}
                onChange={e => setCategory(e.target.value)}
                className="form-control"
                placeholder="Category" />
            </dd>
          </>}
          {!isEditing && <>
            <dt>Payee</dt>
            <dd>{transaction.payee_name || "Unknown"}</dd>
            <dt>Category</dt>
            <dd>{transaction.category}</dd>
          </>}
          <dt>Account</dt>
          <dd>{transaction.account_name}</dd>
          <dt>Description</dt>
          <dd>{transaction.description}</dd>
        </dl>
        <hr />

        <Actions onClose={onClose}
          transaction={transaction}
          setIsEditing={setIsEditing}
          onSave={onSave}
          isEditing={isEditing} />

      </Offcanvas.Body>
    </Offcanvas>
  );
}

function Actions({ transaction, onClose, setIsEditing, isEditing, onSave }) {
  const [payee, setPayee] = useState(null);
  const [loading, setLoading] = useState(false);

  const hasPayee = transaction.payee_id !== null;

  async function createPayee() {
    setLoading(true);
    const { data } = await apiClient.get(`/api/transactions/${transaction.id}/create_payee`);
    setLoading(false);
    setPayee(data);
  }

  async function editPayee() {
    const { data } = await apiClient.get(`/api/payees/${transaction.payee_id}`);
    setPayee(data);
  }

  const createOrEdit = hasPayee ? "edit the payee" : "create a new payee";
  return (
    <>
      <div className={"d-flex justify-content-end"}>
        {loading && <div className="spinner-border text-light" role="status" />}
        {!isEditing && <button
          className="btn btn-secondary ms-2"
          disabled={loading}
          onClick={() => setIsEditing(true)}>
          Edit Transaction
        </button>}
        {!isEditing && !hasPayee && <button
          className={"btn btn-primary ms-2"}
          disabled={loading}
          onClick={createPayee}>
          Create Payee
        </button>}
        {!isEditing && hasPayee && <button
          className={"btn btn-primary ms-2"}
          disabled={loading}
          onClick={editPayee}>
          Edit Payee
        </button>}
        {isEditing && <>
          <button
            className={"btn btn-secondary ms-2"}
            disabled={loading}
            onClick={() => setIsEditing(false)}>
            Cancel
          </button>
          <button
            className={"btn btn-primary ms-2"}
            disabled={loading}
            onClick={onSave}>
            Save
          </button>
        </>}

      </div>

      <div className="mt-3 text-lighter fst-italic">
        {!isEditing && <>
          <p>
            You can {createOrEdit} for this transaction to categorize it and other similar
            transactions.
          </p>
          <p>
            Alternatively, if this is a "one-off" transaction, you can edit the transaction
            individually.
          </p>
        </>}
        {isEditing && <>
          <p>
            All changes will be applied to this transaction only. To apply changes to all similar
            transactions, {createOrEdit} for this transaction.
          </p>
        </>}

      </div>
      {payee && <EditPayee payee={payee} onHide={onClose} />}
    </>
  );
}

